import React, { Children, Fragment, type ComponentProps, type ReactElement } from 'react';
import { useIntl } from 'react-intl-next';

import type { TaskList as OriginalTaskList } from '@atlaskit/renderer/nodes';
import { messages } from '@atlaskit/task-decision/messages';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const TaskList = (
	props: ComponentProps<typeof OriginalTaskList> & LightNodeProps,
): ReactElement => {
	const intl = useIntl();

	if (Children.count(props.children) === 0) {
		return <Fragment />;
	}

	return (
		<div
			ref={props.lightNodeRef}
			aria-label={intl.formatMessage(messages.fieldsetLabel)}
			data-task-list-local-id={props.localId}
			role="group"
		>
			{props.children}
		</div>
	);
};
